import Image from 'next/image';

const Ilustracion = () => {
  return (
    <>
      <Image
        src="/images/formar-parte/1.svg"
        width={216}
        height={216}
        alt=""
        className="absolute top-0 sm:top-[8%] left-[-10%] sm:left-0 w-120 sm:w-215 image-1-js"
      />
      <Image
        src="/images/formar-parte/2.svg"
        width={272}
        height={272}
        alt=""
        className="absolute top-0 sm:top-auto sm:bottom-0 left-[10%] sm:left-[25%] w-165 sm:w-270 image-2-js"
      />
      <Image
        src="/images/formar-parte/3.svg"
        width={260}
        height={260}
        alt=""
        className="absolute top-0 sm:top-auto sm:bottom-0 right-[10%] sm:right-[25%] w-160 sm:w-260 image-3-js"
      />
      <Image
        src="/images/formar-parte/4.svg"
        width={216}
        height={216}
        alt=""
        className="absolute top-0 sm:top-[8%] right-[-10%] sm:right-30 w-120 sm:w-215 image-4-js"
      />
    </>
  );
};
export default Ilustracion;
